<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/noE4ZN/tc-custom/9780253064981.jpg?1724535527205" alt="This image is the cover for the book Uprooting the Diaspora, The Modern Jewish Experience"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uprooting the Diaspora, The Modern Jewish Experience
      </h1>
      <p class="bookDescription body article font2">
        <p>In <i>Uprooting the Diaspora</i>, Sarah Cramsey explores how the Jewish citizens rooted in interwar Poland and Czechoslovakia became the ideal citizenry for a post–World War II Jewish state in the Middle East. She asks, how did new interpretations of Jewish belonging emerge and gain support amongst Jewish and non-Jewish decision makers exiled from wartime east central Europe and the powerbrokers surrounding them? <br/> <br/>Usually, the creation of the State of Israel is cast as a story that begins with Herzl and is brought to fulfillment by the Holocaust. To reframe this trajectory, Cramsey draws on a vast array of historical sources to examine what she calls a "transnational conversation" carried out by a small but influential coterie of Allied statesmen, diplomats in international organizations, and Jewish leaders who decided that the overall disentangling of populations in postwar east central Europe demanded the simultaneous intellectual and logistical embrace of a Jewish homeland in Palestine as a territorial nationalist project. </p><p><i>Uprooting the Diaspora</i> slows down the chronology between 1936 and 1946 to show how individuals once invested in multi-ethnic visions of diasporic Jewishness within east central Europe came to define Jewishness primarily in ethnic terms. This revolution in thinking about Jewish belonging combined with a sweeping change in international norms related to population transfers and accelerated, deliberate postwar work on the ground in the region to further uproot Czechoslovak and Polish Jews from their prewar homes. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah A. Cramsey
      </h2>
      
      <p class="authorDescription body article"><P>Sarah A. Cramsey is a historian of east-central Europe, the global Jewish experience, and the significant Jewish diasporas unleased from the lands between Berlin and Moscow in the 1940s. She teaches Judaism and Diaspora Studies at Leiden University.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f3273422